import { Localized } from '../../localization/react'
import { Interval, isRepeatingShorterThanValidity, Repeating } from '../../typings/Product'

interface RenewalInfoProps {
  repeating?: Repeating | null
  validityDuration?: Interval | null
}

export const RenewalInfo = ({ repeating = null, validityDuration = null }: RenewalInfoProps) => {
  if (!repeating || !isRepeatingShorterThanValidity(repeating, validityDuration)) return null

  return <Localized id="abpr-units-renew-caption" params={{ intervalType: repeating.interval.type as any }} />
}
